import React, {useEffect, useState} from 'react'
import {Container, Grid, Popup, Table} from 'semantic-ui-react';
import {fetchPeopleCourses} from "../../../../redux/actions";
import moment from "moment";

const token = sessionStorage.getItem('Token')

const DrawItem = (item) => {
    return (
        <Table.Row>
            <Table.Cell textAlign={"right"}>{item.id}</Table.Cell>
            <Table.Cell>{item.course.name}</Table.Cell>
            <Table.Cell textAlign={"right"}>{item.total}</Table.Cell>
            <Table.Cell textAlign={"center"}>{moment(item.created_at).format('DD/MM/YYYY HH:mm:ss')}</Table.Cell>
            <Table.Cell>{item.course.free ? 'Grátis' : item.status_text}</Table.Cell>
        </Table.Row>
    );
}

export const Orders = () => {

    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);

    const fetchData = async () => {
        setLoading(true);

        try {
            const res = await fetchPeopleCourses({active: 1, product: 1});

            setItems(res.data);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        async function getData() {
            await fetchData();
        }

        // noinspection JSIgnoredPromiseFromCall
        getData();
    }, [token]);

    return (
        <Container>
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <Table celled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={2} textAlign={"center"}>Código</Table.HeaderCell>
                                    <Table.HeaderCell>Descrição</Table.HeaderCell>
                                    <Table.HeaderCell width={2} textAlign={'center'}>Valor</Table.HeaderCell>
                                    <Table.HeaderCell width={2} textAlign={'center'}>Data</Table.HeaderCell>
                                    <Table.HeaderCell width={2} textAlign={'center'}>Situação</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {
                                    items.map((item) => DrawItem(item))
                                }
                            </Table.Body>
                        </Table>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    )
}